import { Loader } from '@fluidframework/container-loader';
import { OdspDocumentServiceFactory, OdspDriverUrlResolver } from '@fluidframework/odsp-driver';
import { MfsContainerFactory } from '@metaos/mfs-client';
import { logVerbose, logVerboseAsync } from '@metaos/mfs-telemetry';
import { logger } from '../logger';
/** Connect to ODSP service and retrieve a Container with the given ID running the given code. */
export async function getOdspContainer(containerConnection, domain, getOdspTokenFn, getPushChannelTokenFn, persistedCache, headers) {
    return logVerboseAsync(logger, 'getOdspContainer', async () => {
        const loader = await createLoader(domain, getOdspTokenFn, getPushChannelTokenFn, persistedCache);
        let container;
        if (typeof containerConnection === 'string') {
            container = await loader.resolve({ url: containerConnection, headers: headers });
        }
        else {
            container = await loader.createDetachedContainer({ package: 'no-dynamic-package', config: {} });
        }
        return container;
    });
}
function createHostStoragePolicy(isMsaUser, persistedCache) {
    return logVerbose(logger, 'createHostStoragePolicy', () => {
        // Undefined properties mean that default odsp-driver values should be used.
        // Setting unauthenticatedUserDisplayName to any value is a temporary hack that allows MSA accounts to be enabled,
        // This code wil change when proper odsp-driver support for MSA is complete
        const hostStoragePolicy = {
            concurrentSnapshotFetch: persistedCache ? true : undefined,
            sessionOptions: {
                unauthenticatedUserDisplayName: isMsaUser ? 'MSA User' : undefined,
                forceAccessTokenViaAuthorizationHeader: isMsaUser ? true : undefined,
            },
        };
        return hostStoragePolicy;
    });
}
/** Connect to ODSP service and create a loader with params specified */
export async function createLoader(domain, getOdspTokenFn, getPushChannelTokenFn, persistedCache) {
    return logVerboseAsync(logger, 'createLoader', async () => {
        const containerRuntimeFactory = MfsContainerFactory;
        const isMsaUser = domain.toLowerCase() === 'my.microsoftpersonalcontent.com';
        const hostStoragePolicy = createHostStoragePolicy(isMsaUser, persistedCache);
        const documentServiceFactory = new OdspDocumentServiceFactory(() => getOdspTokenFn(domain), isMsaUser ? undefined : getPushChannelTokenFn, persistedCache, hostStoragePolicy);
        const urlResolver = new OdspDriverUrlResolver();
        // @todo: (crtargos) This is pulled from the Tinylicious code. How does this affect MFS?
        // To bypass proposal-based loading, we need a codeLoader that will return our already-in-memory container factory.
        // The expected format of that response is an IFluidModule with a fluidExport.
        const load = async () => {
            return {
                module: { fluidExport: containerRuntimeFactory },
                details: { package: 'no-dynamic-package', config: {} },
            };
        };
        const codeLoader = { load };
        const loader = new Loader({ urlResolver, documentServiceFactory, codeLoader });
        return loader;
    });
}
//# sourceMappingURL=getOdspContainer.js.map